import { DateInput } from 'react-admin'
import moment from 'moment'

const CustomMonthInput = ({ source, ...props }) => {
  const transformValue = value => {
    if (!value) return value
    // Transform the date to YYYY-MM format when sending to backend
    return moment(value).format('YYYY-MM')
  }

  return <DateInput source={source} parse={transformValue} {...props} />
}

export default CustomMonthInput
